export const offerings = [
  {
    id: 'noetivra',
    tag: 'Interactive workspace · Coming soon',
    title: 'Noetivra',
    body: 'Noetivra brings SyNeural’s knowledge and capability resources into an interactive workspace. People can explore knowledge maps, complete assessments, compare findings, follow development pathways, and document decisions through modules suited to their needs.',
    example: '',
    link: '/noetivra',
    linkLabel: 'Explore Noetivra',
  },
  {
    id: 'semantic-knowledge',
    tag: 'Knowledge infrastructure',
    title: 'Semantic Knowledge Platform',
    body: 'The Semantic Knowledge Platform (SKP) is the knowledge infrastructure beneath SyNeural’s products. It turns scattered research and content into connected, usable knowledge: it defines concepts and relationships, links evidence across sources, and combines knowledge graphs, semantic search, and AI-assisted discovery with expert review.',
    example:
      'A research organization, for example, could use the platform to connect studies, researchers, institutions, publications, and findings—making it easier to trace a claim back to its sources and discover related evidence.',
    link: '/semantic-knowledge',
    linkLabel: 'Explore the Semantic Knowledge Platform',
  },
  {
    id: 'human-capability',
    tag: 'Assessment & development framework · CJI · NCJI',
    title: 'Human Capability Platform',
    body: 'The Human Capability Platform brings together SyNeural’s assessment and development frameworks and supporting services. Through CJI and NCJI, it examines the capabilities behind sound judgment, including reasoning, evidence evaluation, self-direction, cooperation, and decision-making under pressure, and connects findings to development across education, civic life, work, public service, and leadership.',
    example: '',
    link: '/human-capability',
    linkLabel: 'Explore the Human Capability Platform',
  },
  {
    id: 'institutional-intelligence',
    tag: 'Capability + connected knowledge',
    title: 'Institutional intelligence',
    body: 'We bring capability frameworks and connected knowledge together to help organizations identify gaps, understand complex problems, design practical responses, and learn from results.',
    example: '',
    link: '/solutions',
    linkLabel: 'See solutions by sector',
  },
]

export const judgmentSteps = [
  {
    title: 'Connect the evidence',
    body: 'Bring research, records, and expertise into a structured system where relationships and sources remain visible.',
  },
  {
    title: 'Develop capability',
    body: 'Help people strengthen the reasoning and judgment needed to interpret information and navigate difficult choices.',
  },
  {
    title: 'Support action',
    body: 'Give teams clearer ways to evaluate options, coordinate work, and review outcomes over time.',
  },
]

export const humanCapabilityProducts = [
  {
    acronym: 'CJI',
    name: 'Civic Judgment Index',
    body: 'A framework for examining the quality of reasoning and judgment in civic and social contexts.',
    link: '/cji',
  },
  {
    acronym: 'NCJI',
    name: 'Neurocognitive Civic Judgment Index',
    body: 'A broader developmental framework connecting human capability, civic resilience, institutional readiness, and leadership responsibility.',
    link: '/ncji',
  },
]

export const audiences = [
  { label: 'Research organizations', link: '/semantic-knowledge' },
  { label: 'Educators', link: '/education' },
  { label: 'Civil society groups', link: '/civil-society' },
  { label: 'Employers', link: '/employers' },
  { label: 'Public institutions', link: '/government' },
]
